import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";

import reportWebVitals from './reportWebVitals';

import Portal from "./Portal";
import PortalTheme from './components/paperbase/PortalTheme';
import { ContentRoutes } from './components/Routing';
import navigation from "./static/navigation";


ReactDOM.render(
  <React.StrictMode>
    <PortalTheme>
      <Router>
        <Portal>
            <ContentRoutes navigation={navigation} />
        </Portal>
      </Router>
    </PortalTheme>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);